<p-dialog *ngIf="visible" [(visible)]="visible"
    [modal]="true"
    appendTo="body"
    [baseZIndex]="20000"
    [breakpoints]="{'960px': '75vw', '640px': '100vw'}" [style]="{width: '75vw'}" styleClass="resumo-eventos-modal">
    <ng-template pTemplate="header">
        <a [routerLink]="['/dashboard/', estacaoSelecionada, data_monitoramento]"
            style="cursor: pointer; text-decoration: none; color: inherit;">
            <h5>
                {{ tituloModal }}
            </h5>
        </a>
    </ng-template>
    
    <div class="container">
        <div class="p-fluid grid">
            <div *ngIf="loading || !modalMonitoramentoPronto" class="p-fluid grid col-12 modalMonitoramento justify-content-center py-4">
                <p-progressSpinner [style]="{width: '50px', height: '50px'}" styleClass="custom-spinner" strokeWidth="8"
                    fill="#EEEEEE" animationDuration=".5s"></p-progressSpinner>
            </div>

            <div *ngIf="modalMonitoramentoPronto" class="col-12">
                <!-- Card de Botões -->
                <div class="buttons-card mb-3 p-p-3 p-shadow-2">
                    <div class="col-12 md:col-12 xl:col-12 p-fluid grid">
                        <div class="col-12 md:col-3 xl:col-3">
                            <button pButton pRipple type="button"
                                class="p-button p-button-warning mr-2 p-button-block"
                                (click)="cancelarMonitoramento()">
                                <i class="pi pi-times mr-2"></i>
                                Cancelar
                            </button>
                        </div>
                        
                        <div class="col-12 md:col-3 xl:col-3">
                            <button pButton pRipple type="button"
                                class="p-button p-button-danger mr-2 p-button-block"
                                (click)="salvarMonitoramento('encerrar')"
                                [disabled]="!podeSalvarEncerrar">
                                <i class="pi pi-save mr-2"></i>
                                Salvar e Encerrar
                            </button>
                        </div>
                        
                        <div class="col-12 md:col-3 xl:col-3">
                            <button pButton pRipple type="button"
                                class="p-button p-button-success mr-2 p-button-block"
                                (click)="salvarMonitoramento('abrir')"
                                [disabled]="!podeSalvar">
                                <i class="pi pi-check mr-2"></i>
                                Salvar
                            </button>
                        </div>
                        
                        <div class="col-12 md:col-3 xl:col-3">
                            <button pButton pRipple type="button"
                                class="p-button p-button-info mr-2 p-button-block"
                                (click)="enviarEmailEstacao()"
                                [disabled]="!podeEnviarEmailUi"
                                [loading]="loadingEnviarEmail">
                                <i class="pi pi-send mr-2"></i>
                                Enviar E-mail
                            </button>
                        </div>
                    </div>
                </div>

                <!-- Card de Monitoramento -->
                <div class="monitoring mb-3 p-p-3 p-shadow-2">
                    <h4 style="text-align: center;">MONITORAMENTO</h4>
                    <div class="p-fluid grid col-12 mb-3">
                        <div class="col-12 md:col-6">
                            <div class="p-fluid grid">
                                <div class="field col-12 mb-2">
                                    <label for="data_hora_monitoramento" class="monitoring-field-label">Data/Hora início do MONITORAMENTO</label>
                                    <p-datepicker
                                        [(ngModel)]="novoMonitoramento.data_hora_monitoramento"
                                        [showTime]="true"
                                        [hourFormat]="'24'"
                                        dateFormat="dd/mm/yy"
                                        [showIcon]="true"
                                        iconDisplay="input"
                                        appendTo="body"
                                        inputId="data_hora_monitoramento"
                                        [maxDate]="maxDate"
                                        [disabled]="monitoramentoFechado"
                                        (onSelect)="onMonitoramentoDataChange()"
                                        [required]="true"
                                        styleClass="monitoring-date-input" />
                                    <small class="p-error" *ngIf="!novoMonitoramento.data_hora_monitoramento">
                                        Campo obrigatório
                                    </small>
                                </div>
                                
                                <div class="field col-12">
                                    <div class="monitoring-date-fim-header">
                                        <label for="data_hora_ultima_situacao" class="monitoring-field-label mb-0">Data/Hora Fim monitoramento</label>
                                        <button
                                            type="button"
                                            pButton
                                            pRipple
                                            label="Em aberto"
                                            class="p-button-text p-button-sm monitoring-em-aberto-btn"
                                            [ngClass]="{'monitoring-em-aberto-btn--active': monitoramentoSemDataFim}"
                                            [disabled]="monitoramentoFechado"
                                            [pTooltip]="monitoramentoSemDataFim
                                                ? 'Monitoramento sem data de encerramento'
                                                : 'Clique para manter o monitoramento em aberto (limpar data fim)'"
                                            tooltipPosition="top"
                                            (click)="limparDataFimMonitoramento()">
                                        </button>
                                    </div>
                                    <p-datepicker
                                        [(ngModel)]="novoMonitoramento.data_hora_ultima_situacao"
                                        [showTime]="true"
                                        [hourFormat]="'24'"
                                        dateFormat="dd/mm/yy"
                                        [showIcon]="true"
                                        iconDisplay="input"
                                        [showClear]="true"
                                        appendTo="body"
                                        inputId="data_hora_ultima_situacao"
                                        [minDate]="minDateEvento"
                                        [maxDate]="maxDate"
                                        [disabled]="monitoramentoFechado"
                                        (onSelect)="onMonitoramentoFimDataChange()"
                                        (onClear)="onMonitoramentoFimDataChange()"
                                        styleClass="monitoring-date-input" />
                                    <small class="p-text-muted">
                                        Obrigatório apenas ao finalizar o monitoramento
                                    </small>
                                </div>
                                
                                <div class="field col-12 mt-2">
                                    <div class="p-checkbox monitoring-checkbox-row">
                                        <p-checkbox 
                                            [(ngModel)]="novoMonitoramento.monitoramento_interno" 
                                            inputId="monitoramento_interno"
                                            [binary]="true">
                                        </p-checkbox>
                                        <label for="monitoramento_interno" class="p-checkbox-label ml-2">
                                            Monitoramento interno
                                        </label>
                                    </div>
                                    <small class="p-text-muted block mt-1">
                                        Quando marcado, os e-mails serão enviados apenas para usuários internos.
                                    </small>
                                </div>
                            </div>
                        </div>
                        
                        <div class="col-12 md:col-6">
                            <div class="p-fluid grid">
                                <div class="field col-12">
                                    <label for="observacao_abertura" class="monitoring-field-label">Observação de Abertura (opcional)</label>
                                    <textarea 
                                        pTextarea 
                                        id="observacao_abertura"
                                        class="monitoring-textarea"
                                        [(ngModel)]="novoMonitoramento.observacao_abertura" 
                                        rows="5"
                                        placeholder="Descreva observações sobre a abertura do monitoramento..."
                                        (focus)="onCampoTextoFocus()"
                                        (blur)="onCampoTextoBlur()">
                                    </textarea>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Card de Eventos -->
                <div class="events">
                    <h4 style="text-align: center;">EVENTOS</h4>
                    
                    <div class="p-fluid grid col-12">
                        <p-message *ngIf="eventosDataSelecionada.length == 0" severity="info"
                            text="Nenhum evento encontrado."></p-message>
                        
                        <div *ngFor="let row of eventosDataSelecionada; let i = index; trackBy: trackByEvento"
                            class="formgrid p-fluid grid col-12 flex mb-2 p-p-1 p-shadow-1 event-row-container">
                            
                            <div class="col-1 flex align-items-center justify-content-center">
                                <i [class]="row.iconeCss"
                                [style.color]="row.cor"
                                style="font-size: 20px"></i>
                            </div>
                            <div class="col-5 flex align-items-center">
                                <span style="font-size: 14px; font-weight: 600; color: #495057;">
                                    {{ row.tipo_evento.descricao }}
                                </span>
                            </div>
                            <div class="col-3 flex align-items-center justify-content-end">
                                <span [pTooltip]="row.tooltip" 
                                    style="font-size: 13px; font-weight: 500; color: #6c757d;">
                                    {{ row.total_computado }} / {{ row.maximo_normalidade_eventos }}
                                </span>
                            </div>
                            
                            <div class="col-3 flex align-items-center justify-content-end">
                                <div class="field-checkbox">
                                    <p-checkbox 
                                        [(ngModel)]="row.selecionadoParaMonitoramento"
                                        [binary]="true"
                                        inputId="monitoramento{{i}}"
                                        label="Monitoramento"
                                        (onChange)="onSelecionarMonitoramento(row, $event)">
                                    </p-checkbox>
                                </div>
                            </div>
                            
                            <div *ngIf="row.selecionadoParaMonitoramento && modalMonitoramentoPronto" class="col-12 p-fluid grid mt-1">
                                <div class="col-12 p-fluid grid event-monitoring-fields">
                                    <div class="field col-12 md:col-2">
                                        <label for="data_hora_inicio{{i}}" class="monitoring-field-label monitoring-field-label-sm">Data/Hora Início</label>
                                        <p-datepicker
                                            [(ngModel)]="row.data_hora_inicio"
                                            [showTime]="true"
                                            [hourFormat]="'24'"
                                            dateFormat="dd/mm/yy"
                                            [showIcon]="true"
                                            iconDisplay="input"
                                            appendTo="body"
                                            inputId="data_hora_inicio{{i}}"
                                            [minDate]="minDateEvento"
                                            [maxDate]="maxDateEvento"
                                            (onSelect)="atualizarEstadoUiMonitoramento()"
                                            styleClass="compact-calendar-inline monitoring-date-input-sm" />
                                    </div>
                                    
                                    <div class="field col-12 md:col-2">
                                        <div class="monitoring-date-fim-header">
                                            <label for="data_hora_fim{{i}}" class="monitoring-field-label monitoring-field-label-sm mb-0">Data/Hora Fim</label>
                                            <button
                                                type="button"
                                                pButton
                                                pRipple
                                                label="Em aberto"
                                                class="p-button-text p-button-sm monitoring-em-aberto-btn"
                                                [ngClass]="{'monitoring-em-aberto-btn--active': row.emAberto}"
                                                [pTooltip]="row.emAberto
                                                    ? 'Evento sem data de encerramento'
                                                    : 'Clique para manter o evento em aberto (limpar data fim)'"
                                                tooltipPosition="top"
                                                (click)="limparDataFimEvento(row)">
                                            </button>
                                        </div>
                                        <p-datepicker
                                            [(ngModel)]="row.data_hora_fim"
                                            [showTime]="true"
                                            [hourFormat]="'24'"
                                            dateFormat="dd/mm/yy"
                                            [showIcon]="true"
                                            iconDisplay="input"
                                            [showClear]="true"
                                            appendTo="body"
                                            placeholder="Opcional"
                                            inputId="data_hora_fim{{i}}"
                                            [minDate]="row.minDateFim"
                                            [maxDate]="maxDateEvento"
                                            (onSelect)="atualizarEstadoUiMonitoramento()"
                                            (onClear)="atualizarEstadoUiMonitoramento()"
                                            styleClass="compact-calendar-inline monitoring-date-input-sm" />
                                    </div>
                                    
                                    <div class="field col-12 md:col-4">
                                        <label class="monitoring-field-label monitoring-field-label-sm">Problema (opcional)</label>
                                        <input 
                                            [id]="'problema_' + i"
                                            pInputText 
                                            class="monitoring-text-input-sm"
                                            [(ngModel)]="row.problema" 
                                            placeholder="Descreva o problema..."
                                            (focus)="onCampoTextoFocus()"
                                            (blur)="onCampoTextoBlur()">
                                    </div>
                                    
                                    <div class="field col-12 md:col-4">
                                        <label class="monitoring-field-label monitoring-field-label-sm">Desfecho (opcional)</label>
                                        <input 
                                            [id]="'desfecho_' + i"
                                            pInputText 
                                            class="monitoring-text-input-sm"
                                            [(ngModel)]="row.desfecho" 
                                            placeholder="Descreva o desfecho..."
                                            (focus)="onCampoTextoFocus()"
                                            (blur)="onCampoTextoBlur()">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</p-dialog>
